(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customdt-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var modal = document.querySelector('[data-customdt-sms-modal]');
      if (!modal) {
        return;
      }

      var emailSuccess = document.querySelector('[data-customdt-email-success]');
      var smsSuccess = modal.querySelector('[data-customdt-sms-success]');

      console.log('[customdt-newsletter]', {
        modal: !!modal,
        emailSuccess: !!emailSuccess,
        smsSuccess: !!smsSuccess
      });

      if (emailSuccess || smsSuccess) {
        openModal(modal);
        if (smsSuccess) {
          setTimeout(function () { closeModal(modal); }, 2500);
        }
      }

      document.querySelectorAll('[data-customdt-sms-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { closeModal(modal); });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!modal.hidden) closeModal(modal);
      });

      function openModal(m) {
        m.hidden = false;
        m.removeAttribute('hidden');
        m.setAttribute('aria-hidden', 'false');
        document.body.classList.add('DT-newsletter-modal-open');
        console.log('[customdt-newsletter] modal opened');
        var input = m.querySelector('input[name="contact[phone]"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }

      function closeModal(m) {
        m.hidden = true;
        m.setAttribute('hidden', '');
        m.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('DT-newsletter-modal-open');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var modal = document.querySelector('[data-customdt-sms-modal]');
      if (!modal) {
        return;
      }

      var emailSuccess = document.querySelector('[data-customdt-email-success]');
      var smsSuccess = modal.querySelector('[data-customdt-sms-success]');

      console.log('[customdt-newsletter]', {
        modal: !!modal,
        emailSuccess: !!emailSuccess,
        smsSuccess: !!smsSuccess
      });

      if (emailSuccess || smsSuccess) {
        openModal(modal);
        if (smsSuccess) {
          setTimeout(function () { closeModal(modal); }, 2500);
        }
      }

      document.querySelectorAll('[data-customdt-sms-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { closeModal(modal); });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!modal.hidden) closeModal(modal);
      });

      function openModal(m) {
        m.hidden = false;
        m.removeAttribute('hidden');
        m.setAttribute('aria-hidden', 'false');
        document.body.classList.add('DT-newsletter-modal-open');
        console.log('[customdt-newsletter] modal opened');
        var input = m.querySelector('input[name="contact[phone]"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }

      function closeModal(m) {
        m.hidden = true;
        m.setAttribute('hidden', '');
        m.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('DT-newsletter-modal-open');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
